import { render, staticRenderFns } from "./js-loader.vue?vue&type=template&id=bed4d6fe"
import script from "./js-loader.vue?vue&type=script&lang=js"
export * from "./js-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports